import { makeStyles } from '@material-ui/core/styles';

export const useStyle = makeStyles((theme) => {
    return {
        carousel: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 20,
            '& h3': {
                margin: 0,
            },
            '& .slick-track': {
                padding: '20px 0',
                marginLeft: 'unset',
                marginRight: 'unset',
            },
            '& .slick-slider.center.slick-initialized': {
                width: '100%',
            },
            '& .slick-arrow::before': {
                content: 'unset',
            },
            '& .slick-arrow.slick-disabled button': {
                transition: '.3s transform',
                transform: 'scale(0)',
            },
            '& .slick-slide > div': {
                margin: '0 20px',
                [theme.breakpoints.down('xs')]: {
                    margin: '0 15px',
                },
            },
            '& .slick-slide.slick-active > div ': {
                marginLeft: 3,
            },
            '& .slick-slide.slick-active:last-child > div ': {
                marginRight: 3,
            },
            '& .slick-prev': { left: -10, zIndex: 1000 },
            '& .slick-next': { right: -10, zIndex: 1000 },
            '& .slick-list': { transform: 'none !important' },
            '& div': {
                height: '100%',
                outline: 'none',
            },
            '& .MuiCard-root': {
                '& div': {
                    height: 'unset',
                },
                '& img': {
                    width: 63,
                    height: 63,
                },
                boxShadow: '0px 0px 4px rgba(0,0,0,0.1)',
                '&:hover': {
                    cursor: 'pointer',
                    boxShadow: '0px 0px 4px rgba(0,0,0,0.2)',
                },
            },
        },
    };
});
